import React, { useEffect, useRef, useState } from "react";
import {
  Container,
  Table,
  Card,
  Button,
  Row,
  Col,
  Form,
  Spinner,
} from "react-bootstrap";
import axios from "axios";
import * as XLSX from "xlsx";
import { useReactToPrint } from "react-to-print";
import { toast } from "react-toastify";
const AdvanceBookingTable = () => {
  const tableRef = useRef();

  const loginUser = JSON.parse(localStorage.getItem("loginUser"));
  const hotelId = loginUser?.hotelid;

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  /* FILTER STATES */
  const [filters, setFilters] = useState({
    fromdate: "",
    todate: "",
    name: "",
    mobileno: "",
  });

  /* ---------------- HANDLE CHANGE ---------------- */
  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  /* ---------------- FETCH DATA ---------------- */
  const fetchBookings = async () => {
    if (!filters.fromdate || !filters.todate) {
      toast.error("Please select From Date & To Date");
      return;
    }

    setLoading(true);

    try {
      const res = await axios.get(
        "https://hotelapi.shriyanshnath.com/api/Get_advance_booking",
        {
          params: {
            fromdate: filters.fromdate,
            todate: filters.todate,
            bookingno: "",
            bookingid: "",
            name: filters.name || "",
            mobileno: filters.mobileno || "",
            hotelid: hotelId,
          },
        }
      );

      setData(res.data || []);
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch bookings");
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- EXCEL EXPORT ---------------- */
  const exportToExcel = () => {
    const excelData = data.map((item, index) => ({
      "S No": index + 1,
      "Guest Name": item.name,
      "Mobile No": item.mobileno,
      PAX: `${item.adult_person} Adult + ${item.child} Child`,
      "Check-in": item.checkin,
      "Check-out": item.checkout,
      Remark: item.remark,
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Advance Bookings");
    XLSX.writeFile(workbook, "Advance_Booking_Report.xlsx");
  };

  /* ---------------- PRINT ---------------- */
  const handlePrint = useReactToPrint({
    content: () => tableRef.current,
  });

  return (
    <Container fluid className="my-4 px-4">
      <Card className="shadow-sm">
        <Card.Body>
          {/* FILTER SECTION */}
          <Row className="mb-3 g-3 align-items-end">
            <Col md={2}>
              <Form.Label>From Date</Form.Label>
              <Form.Control
                type="date"
                name="fromdate"
                value={filters.fromdate}
                onChange={handleChange}
              />
            </Col>

            <Col md={2}>
              <Form.Label>To Date</Form.Label>
              <Form.Control
                type="date"
                name="todate"
                value={filters.todate}
                onChange={handleChange}
              />
            </Col>

            <Col md={3}>
              <Form.Label>Guest Name</Form.Label>
              <Form.Control
                placeholder="Search Name"
                name="name"
                value={filters.name}
                onChange={handleChange}
              />
            </Col>

            <Col md={3}>
              <Form.Label>Mobile No</Form.Label>
              <Form.Control
                placeholder="Search Mobile"
                name="mobileno"
                value={filters.mobileno}
                onChange={handleChange}
              />
            </Col>

            <Col md={2}>
              <Button className="w-100" onClick={fetchBookings}>
                Search
              </Button>
            </Col>
          </Row>

          {/* ACTION BUTTONS */}
          <Row className="mb-3">
            <Col className="text-end">
              <Button
                variant="success"
                className="me-2"
                onClick={exportToExcel}
              >
                Export Excel
              </Button>
              <Button variant="primary" onClick={handlePrint}>
                Print
              </Button>
            </Col>
          </Row>

          {/* TABLE */}
          {loading ? (
            <div className="text-center py-4">
              <Spinner animation="border" />
            </div>
          ) : (
            <div ref={tableRef}>
              <Table bordered hover responsive className="text-center">
                <thead className="table-dark">
                  <tr>
                    <th className="text-nowrap">#</th>
                    <th className="text-nowrap">Name</th>
                    <th className="text-nowrap">Mobile</th>
                    <th className="text-nowrap">PAX</th>
                    <th className="text-nowrap">Check-in</th>
                    <th className="text-nowrap">Check-out</th>
                    <th className="text-nowrap">Remark</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length === 0 ? (
                    <tr>
                      <td colSpan="7">No Records Found</td>
                    </tr>
                  ) : (
                    data.map((item, index) => (
                      <tr key={item.id}>
                        <td>{index + 1}</td>
                        <td>{item.name}</td>
                        <td>{item.mobileno}</td>
                        <td>
                          {item.adult_person}A + {item.child}C
                        </td>
                        <td>{item.checkin}</td>
                        <td>{item.checkout}</td>
                        <td>{item.remark || "-"}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </div>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default AdvanceBookingTable;
